/**
 * fetch the value from session storage for given key or return default value if doesn't exist
 **/
export function getlocalStorageOrDefault(key, defaultValue) {
  const stored = localStorage.getItem(key);
  if (!stored) {
    return defaultValue;
  }
  return stored;
}

export const getUserInfo = () => {
  const info = JSON.parse(localStorage.getItem("userInfo"));

  return info;
};

export const getUserName = () => {
  const info = getUserInfo();
  return info?.name || "-NA-";
};

export const getUserEmail = () => {
  const info = getUserInfo();
  return info?.email;
};

export const getUserRole = () => {
  const info = getUserInfo();
  return info?.role || "-NA-";
};
